import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import constants from 'src/constants';
import uiDux from 'src/redux/ui';
import breakpointUtils from 'src/utils/breakpointUtils';
import { ModeButtonsContainer, ModeButtonRow } from './styled';
import ModeButton from './ModeButton';

const { MODE_NAMES } = constants.app;

const mapStateToProps = ({ designPro, machete }) => ({
  isSidebarOpen: designPro.ui.isSidebarOpen,
  isInScreenshotMode: designPro.app.activeMode === MODE_NAMES.SCREENSHOT,
  shouldShowMeasureMode: designPro.ui.shouldShowMeasureMode,
  loading: machete.model.loading,
  initialized: machete.model.initialized,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleDesignModeClick: uiDux.actions.handleDesignModeClick,
      handleMeasureModeClick: uiDux.actions.handleMeasureModeClick,
    },
    dispatch,
  );

export class ModeSelector extends PureComponent {
  // eslint-disable-next-line
  static propTypes = {
    handleDesignModeClick: PropTypes.func.isRequired,
    handleMeasureModeClick: PropTypes.func.isRequired,
    initialized: PropTypes.bool.isRequired,
    isInScreenshotMode: PropTypes.bool.isRequired,
    isSidebarOpen: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    shouldShowMeasureMode: PropTypes.bool.isRequired,
  };

  render() {
    const {
      handleDesignModeClick,
      handleMeasureModeClick,
      initialized,
      isInScreenshotMode,
      isSidebarOpen,
      loading,
      shouldShowMeasureMode,
    } = this.props;

    if (isSidebarOpen || loading || !initialized || isInScreenshotMode)
      return null;

    return (
      <ModeButtonsContainer>
        <ModeButtonRow data-selenium="modeButtonRow">
          <ModeButton
            name={MODE_NAMES.DESIGN}
            handleClick={handleDesignModeClick}
          />
          {shouldShowMeasureMode && (
            <ModeButton
              name={MODE_NAMES.MEASURE}
              handleClick={handleMeasureModeClick}
            />
          )}
        </ModeButtonRow>
      </ModeButtonsContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModeSelector);
